import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {ClassType, CustomDataTableSortLogic, Format, PrimeNgConfig, TableColumn, TableFormat, Transaction} from "@app/shared";
import {SortMeta} from "primeng/api";

@Component({
  selector: 'app-abstract-data-table',
  templateUrl: './abstract-data-table.component.html',
  styleUrls: ['./abstract-data-table.component.css']
})
export class AbstractDataTableComponent implements OnInit {

  ClassType: typeof ClassType = ClassType;
  Format: typeof Format = Format;
  PrimeNgConfig = PrimeNgConfig;
  TableFormat: typeof TableFormat = TableFormat;
  Transaction: typeof Transaction = Transaction;

  @Input() columns: TableColumn[];
  @Input() value: any[];
  @Input() dataKey: string;
  @Input() sortField: string;
  @Input() sortMode: string;
  @Input() sortOrder: number;
  @Input() multiSortMeta: SortMeta[];
  @Input() customSort: boolean;
  @Input() customSortField: string;
  @Input() customSortLogic: CustomDataTableSortLogic;
  @Input() contextMenu: any;
  @Input() rows: number;
  @Input() enableAllRowExpansion: boolean;
  @Input() selectionMode: string;

  @Input() enabledExport: boolean;
  @Input() exportUsingTableColumn: boolean;
  @Input() exportTableColumns: string[];
  @Input() exportFileName: string;

  @Input() captionTemplate: TemplateRef<any>;
  @Input() searchCaptionTemplate: TemplateRef<any>;
  @Input() leftCaptionTemplate: TemplateRef<any>;
  @Input() rightCaptionTemplate: TemplateRef<any>;
  @Input() headerTemplate: TemplateRef<any>;
  @Input() bodyTemplate: TemplateRef<any>;
  @Input() summaryTemplate: TemplateRef<any>;
  @Input() emptyMessageTemplate: TemplateRef<any>;
  @Input() rowExpansionTemplate: TemplateRef<any>;
  @Input() footerTemplate: TemplateRef<any>;
  @Input() globalFilterFields: string[];

  @Input() paginator: boolean = true;
  @Input() disablePagination: boolean = false;
  @Input() rowsPerPageOptions: any[];
  @Input() disableSearch: boolean = false;
  @Input() disableEmptyMessage: boolean = false;

  @Input() orgIds: number[];

  _contextMenuSelection: any;
  @Input()
  set contextMenuSelection(val: any) {
    this.contextMenuSelectionChange.emit(val);
    this._contextMenuSelection = val;
  }

  get contextMenuSelection(): any {
    return this._contextMenuSelection;
  }

  @Output() contextMenuSelectionChange = new EventEmitter<any>();

  _selection: any;
  @Input()
  set selection(val: any) {
    this.selectionChange.emit(val);
    this._selection = val;
  }

  get selection(): any {
    return this._selection;
  }

  @Output()
  selectionChange = new EventEmitter<any>();

  @Output()
  handleReloadValue = new EventEmitter<any>();

  @Output()
  handleRowExpanded = new EventEmitter<any>();

  allRowsExpanded: boolean = false;

  constructor() {
  }

  ngOnInit(): void {
  }

  setDefaultProperties(): void {
    this.paginator = !this.disablePagination;
    if (!this.sortMode) {
      this.sortMode = "single";
    }
    if (!this.rows) {
      this.rows = PrimeNgConfig.TableRows;
    }
    if (!this.sortOrder) {
      this.sortOrder = PrimeNgConfig.TableDesSortOrder;
    }
  }

  onRowExpanded(event): void {
    this.handleRowExpanded.emit(event);
  }

  consoleLog(obj) {
    console.log(obj);
  }
}
